import { computed } from 'vue'
import Child from '../../store/models/Child'
import { useRepo } from 'pinia-orm'

export const useScreenTime = (child: Child) => {
  const screenTime = computed(() => {
    if (!child) {
      return 0
    }

    const repo = useRepo(Child)
    const childRecord = repo.with('screenTimeEvents').find(child.id)
    if (!childRecord) {
      return 0
    }

    const screenTimeEvents = childRecord.screenTimeEvents || []

    // Calculate total screen time
    const totalScreenTime = screenTimeEvents.reduce((total, event) => {
      return total + event.impact
    }, 0)

    return totalScreenTime
  })

  function logMap(x) {
    const C = Math.log(16) / 0.2 // Precomputed normalization constant
    return Math.log(x + 1) / C
  }

  const screenTimePercentage = computed(() => {
    // return a logarithmic scale of the screen time
    // 0% => 0mins
    // 20% => 15mins
    // 100% => infinity

    const isPositive = screenTime.value >= 0
    const absTime = Math.abs(screenTime.value)

    const percentage = logMap(absTime) * 100

    return {
      percentage,
      isPositive,
    }
  })

  const screenTimeLabel = computed(() => {
    // For <=30 show just the number
    // for >30-<120 show e.g. 60mins
    // for >120 show e.g. 2h 30m
    const totalScreenTime = screenTime.value
    const hours = Math.floor(totalScreenTime / 60)
    const minutes = totalScreenTime % 60
    const hoursLabel = hours > 0 ? `${hours}h` : ''
    const minutesLabel = minutes > 0 ? `${minutes}m` : ''
    if (totalScreenTime <= 30) {
      return `${totalScreenTime}m`
    }
    if (totalScreenTime > 30 && totalScreenTime < 120) {
      return `${totalScreenTime} m`
    }
    if (totalScreenTime >= 120) {
      return `${hoursLabel} ${minutesLabel}`.trim()
    }
    return ''
  })

  return {
    screenTime,
    screenTimePercentage,
    screenTimeLabel,
  }
}
